import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TDeleteNetPayDuplicateBankAccountSuppressionRequest,
  TDeleteNetPayDuplicateBankAccountSuppressionResponse,
} from "./deleteNetPayDuplicateBankAccountSuppression.schema";

const URL = "/api/net-pay-duplicate-bank-account-suppressions";

export const deleteNetPayDuplicateBankAccountSuppression = (
  axios: IAxiosInstance
) => {
  return async (
    requestBody: TDeleteNetPayDuplicateBankAccountSuppressionRequest
  ) => {
    const response = await axios.noRetry.delete<
      IApiResponse<TDeleteNetPayDuplicateBankAccountSuppressionResponse>
    >(URL, {
      data: requestBody,
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
